//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import languageList from '~/static/json/languageList.json'
import allPages from '~/static/json/allPages.json'
import { add, assign, cloneDeep, throttle, hasIn, getScrollBarWidth } from '~/assets/js/utils.js'
export default {
  components: {
    'login-box': () => import('~/components/login/loginBox.vue'/* webpackChunkName: 'loginBox' */)
    // 'google-login': () => import('~/components/login/quickGoogleLogin.vue'/* webpackChunkName: 'quickGoogleLogin' */)
  },
  data () {
    return {
      // 页面字段
      huntObj: { showMask: true, showBox: true, showInput: false }, // 是否展示搜索框，并打开遮罩
      myEntry: '', // 用户输入的内容（用于搜索）
      traderList: [], // 搜索到的结果
      langList: languageList, // 语言列表
      userLink: [], // 用户登录后可跳转到个人中心的链接
      pcMenuList: [], // 二级菜单（web端）
      visible: [], // 二级可见菜单
      invisible: [], // 二级不可见菜单
      active: '0', // 二级菜单选中项
      sidesObj: { langPop: true, menuPop: true, showSides: false }, // 是否展示侧边栏菜单导航（移动端）
      // 其他
      equipmentType: '', // 设备类型
      scrollBar: 0 // 滚动条宽度
    }
  },
  computed: {
    ...mapState(['isMobile', 'riskObjData', 'suffix', 'inChina']),
    // 当前页面路由
    currentPath () {
      return this.$route?.fullPath?.replace(`/${this.currLangCode()}`, '') || '/'
    },
    // 当前语言
    langName () {
      return languageList?.find(item => item.LanguageCode == this.currLangCode())?.Language || 'English'
    },
    // WikiFX首页链接
    breadHost () {
      return this.$store?.getters?.breadHome
    },
    // 页面是否滚动监听
    rollListen () {
      return ['lang'].includes(this.$route?.name)
    },
    // 从VueX中获取用户信息
    getUser () {
      return (key = '') => this.$store?.state?.simpleUser[key] || ''
    },
    allLanguageList () {
      return languageList
    },
    noChineseLanguageList () {
      return languageList.filter(item => item.LanguageCode != 'zh-cn' && item.LanguageCode != 'zh')
    }
  },
  watch: {
    // 监听设备类型（屏幕宽度）的变化
    equipmentType (newV) {
      let editionHeart = 940
      switch (newV) {
        case 'pc':
          editionHeart = 690
          break
        case 'pad':
          editionHeart = 510
          break
        default: break
      }
      this.calMenu(editionHeart)
    }
  },
  created () {
    // 菜单列表某几项是否展示
    const { ea = true, vps = true } = this.$store?.state?.showMenu
    let pendArr = [
      { name: this.$t('TYY_000005'), url: '/{0}/' },
      { name: 'VPS', url: '/{0}/vps.html' },
      { name: this.$t('TYY_000092'), url: '/{0}/data/holdposition.html' },
      { name: this.$t('TYY_000291'), url: '/{0}/data/EnvRanking.html' },
      { name: this.$t('TYY_000153'), url: '/{0}/data/BurstData.html' },
      { name: 'EA', url: '/{0}/eashop.html' },
      { name: this.$t('24702'), url: '/{0}/data/tradingquotes.html' },
      { name: this.$t('24704'), url: '/{0}/data/cashflow.html' },
      { name: this.$t('24708'), url: '/{0}/data/deeptracking.html' },
      { name: this.$t('40365'), url: '/{0}/help/help-list.html' }
    ]
    pendArr?.forEach((item, index) => {
      item.code = String(add(index, 1))
      const currLink = item.url?.replace('{0}', this.currLangCode())
      item.url = currLink
      item.mUrl = hasIn(item, 'mUrl') ? item.mUrl?.replace('{0}', this.currLangCode()) : currLink
    })
    if (!vps) pendArr = pendArr.filter(item => item.id != '2') // 是否展示VPS菜单栏
    if (!ea) pendArr = pendArr.filter(item => item.id != '6') // 是否展示EA商城菜单栏
    this.pcMenuList = cloneDeep(pendArr)
    this.visible = cloneDeep(pendArr)
    // 高亮菜单选中项
    const { name = '' } = this.$route
    const { id = '0' } = allPages?.find(item => item.route == name) || {}
    this.active = id
    // 处理用户登录后可跳转到个人中心的链接
    const personLink = (!this.filterSpecial() ? [{ name: this.$t('TYY_000484'), link: `${this.breadHost}usercenter/index.html`, icon: 'icon-zhongxin' }, { name: this.$t('22498'), link: `${this.breadHost}usercenter/trader.html`, icon: 'icon-guanzhu' }, { name: this.$t('TYY_000485'), link: `${this.breadHost}usercenter/vip.html`, icon: 'icon-dingdan' }, { name: this.$t('TYY_000486'), link: `${this.breadHost}usercenter/exposure.html`, icon: 'icon-fabu' }, { name: this.$t('22499'), link: `${this.breadHost}usercenter/epc.html`, icon: 'icon-danbao' }, { name: this.$t('TYY_000488'), link: `${this.breadHost}usercenter/setting.html`, icon: 'icon-set' }] : [])
    this.userLink = [...personLink, { name: this.$t('TYY_000543'), link: 'javascript:;', icon: 'icon-quit' }]
  },
  mounted () {
    this.scrollBar = getScrollBarWidth() // 获取滚动条宽度
    // 监听屏幕宽度变化，实时反馈至VueX
    this.screenFn()
    this.screenFn = throttle(this.screenFn, 300)
    this.scrollFn = throttle(this.scrollFn, 300)
    window?.addEventListener('resize', this.screenFn)
    // 根据条件判断是否需要监听屏幕滚动
    if (this.rollListen) document.addEventListener('scroll', this.scrollFn) // 指定页面滚动监听
    document.body?.addEventListener('click', this.bodyFn)
    // 添加站长统计代码
    const googleTag = document.createElement('script')
    googleTag.async = true
    if (this.inChina) { // 国内版
      const cnzzTag = document.createElement('span')
      cnzzTag.id = 'cnzz_stat_icon_1280702904'
      cnzzTag.style = 'display:none;'
      googleTag.src = 'https://s23.cnzz.com/z_stat.php?id=1280702904&show=pic1'
      document.getElementsByTagName('body')[0].appendChild(cnzzTag)
      document.getElementsByTagName('body')[0].appendChild(googleTag)
      const baiduTag = document.createElement('script')
      baiduTag.src = 'https://hm.baidu.com/hm.js?081be77cf69a389085f14465e59cca3b'
      document.getElementsByTagName('body')[0].appendChild(baiduTag)
    } else { // 国际版
      googleTag.src = 'https://www.googletagmanager.com/gtag/js?id=UA-172151915-8'
      const googleTag2 = document.createElement('script')
      googleTag2.src = 'https://www.googletagmanager.com/gtag/js?id=UA-172151915-8'
      googleTag2.async = true
      document.getElementsByTagName('body')[0].appendChild(googleTag)
      document.getElementsByTagName('body')[0].appendChild(googleTag2)
      window.dataLayer = window?.dataLayer || []
      gtag('js', new Date())
      gtag('config', 'UA-172151915-8')
      gtag('config', 'G-8WQ1KZN2WL')
    }
    function gtag () {
      dataLayer.push(arguments) // eslint-disable-line
    }
  },
  beforeDestroy () {
    window?.removeEventListener('resize', this.screenFn)
    if (this.rollListen) document?.removeEventListener('scroll', this.scrollFn)
    document.body?.removeEventListener('click', this.bodyFn)
    window.dataLayer = null
  },
  methods: {
    // 计算菜单栏宽度，是否隐藏几个菜单项
    calMenu (maxWidth = 940) {
      this.visible = cloneDeep(this.pcMenuList)
      const calTimer = setTimeout(() => {
        clearTimeout(calTimer)
        const domList = document.getElementsByClassName('menu-nav')
        let [see, hidden, currWidth] = [[], [], 0] // 菜单项长度求和
        for (let i = 0; i < domList.length; i++) {
          currWidth += (domList[i]?.offsetWidth + (i > 0 ? 8 : 0))
          if (currWidth >= maxWidth) {
            hidden = this.pcMenuList.slice(-(this.pcMenuList.length - see.length))
            break
          }
          see = this.pcMenuList.slice(0, i + 1)
        }
        this.visible = cloneDeep(see)
        this.invisible = cloneDeep(hidden)
      }, 0)
    },
    // 展示搜索框，并打开遮罩
    expandInput (isOpen = false) {
      assign(this.huntObj, isOpen ? { showMask: false, showBox: false } : { showInput: false })
      if (!isOpen) { // 关闭时，清空搜索结果，清空用户输入的内容
        this.traderList = []
        this.myEntry = ''
      }
      const expandTimer = setTimeout(() => {
        clearTimeout(expandTimer)
        assign(this.huntObj, isOpen ? { showInput: true } : { showMask: true, showBox: true })
      }, isOpen ? 0 : 200)
    },
    // 实时搜索
    async realTimeSearch () {
      if (!this.myEntry?.trim()?.length) { // 未输入，不执行后续操作
        this.traderList = []
        return false
      }
      if (this.isReq) return false // 接口正在请求中
      this.isReq = true // 请求开始
      try {
        const data = await this.$api.home.dropdown({ content: this.myEntry, project: 1, type: 1 })
        data?.forEach((item) => {
          item.showName = item.name?.replace(this.myEntry, `<span class="my-words">${this.myEntry}</span>`)
        })
        this.traderList = cloneDeep(data || [])
      } catch (err) {}
      this.isReq = false // 请求结束
    },
    // 点击搜索跳转页面
    searchFn () {
      if (!this.myEntry?.trim()?.length) return false // 未输入，不执行后续操作
      window?.open(`${this.breadHost}search.html?keyword=${this.myEntry}`)
    },
    // 打开/关闭侧边栏弹框
    dialogFn (isOpen = false, domName = 'langPop') {
      assign(this.sidesObj, isOpen ? { [domName]: false } : { showSides: false }) // 打开弹框时，先移除隐藏样式；关闭弹框时，内容区先消失
      const openTimer = setTimeout(() => {
        clearTimeout(openTimer)
        assign(this.sidesObj, isOpen ? { showSides: true } : { [domName]: true }) // 打开弹框一段时间后，内容区才出现；关闭弹框一段时间后，才添加隐藏样式
      }, 50)
    },
    // 用户登录
    loginFn () {
      this.dialogFn(false, 'menuPop')
      this.$store.commit('setVal', { loginShow: true })
    },
    // 退出登录
    logout (val = '') {
      if (val != 'icon-quit') return false
      this.dialogFn(false, 'menuPop')
      this.$cookies.remove('DJkdikKMG', this.$store.getters.cookConf)
      this.$cookies.remove('ViLartidlakd', this.$store.getters.cookConf)
      this.$cookies.remove('WsdsfgDGdagYms')
      this.$cookies.remove('EnterpriseCode')
      this.$store.commit('setVal', { cookieVal: '', simpleUser: {} })
      this.$nextTick(() => { location.reload(true) }) // 页面刷新
    },
    // 监听屏幕宽度的变化
    screenFn () {
      const deviceWidth = add(document?.body?.clientWidth || 0, this.scrollBar)
      this.$store.commit('setVal', { screenWidth: deviceWidth, isMobile: deviceWidth < 800 })
      this.equipmentType = deviceWidth >= 1200 ? 'web' : (deviceWidth >= 1000 ? 'pc' : (deviceWidth >= 800 ? 'pad' : 'mobile')) // 根据屏幕宽度选择设备类型
    },
    // 页面滚动
    scrollFn () {
      const distance = document?.documentElement?.scrollTop || document?.body?.scrollTop
      this.$store.commit('setVal', { scrollDistance: distance })
    },
    // body点击事件
    bodyFn () {
      this.expandInput()
    }
  }
}
